import { Button } from '@bambi/component-library/src/components/Button/Button';
import { ArchiveBoxIcon } from '@heroicons/react/24/outline';


type ArchiveActionProps = {
  className?: string;
  onClick: () => void;
  label: string;
  disabled?: boolean;
};

export function ArchiveAction({
  className,
  onClick,
  label,
  disabled,
}: ArchiveActionProps) {
  return (
    <Button
      className={`${className}`}
      onClick={onClick}
      variant="danger"
      disabled={disabled}
    >
      <ArchiveBoxIcon className="mr-2 w-5" /> {label}
    </Button>
  );
}
